import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Stack, Tab, Tabs, tabsClasses } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import Helpers from "../../../helpers/helpers";
import { getConfigurationDetails, getConfigurationListing } from "../../../store/actions";
import "../../Orders/order.css";

const ProductSpec = ({ setFormValues, values, error, categoryForTab, configurationListing, configurationDetails, width }) => {
  const dispatch = useDispatch()

  const [TabsData, setTabsData] = useState(configurationListing)
  const [tabValue, setTabValue] = useState(0)
  const [tabValueID, setTabValueId] = useState(Helpers.getTabIdFromIndex(configurationListing, tabValue))

  useEffect(() => {
    if (tabValue !== null && tabValue !== undefined && tabValue !== "") {
      let tabID = Helpers.getTabIdFromIndex(configurationListing, tabValue) || ""
      if (typeof tabID === "number") {
        dispatch(getConfigurationDetails({ id: tabID }));
        setTabValueId(tabID)
      }
    }
  }, [configurationListing, tabValue]);

  useEffect(() => {

    let payload = {
      paginate: 0,
      sort_order: "asc",
      size: "",
      search: "",
      sort: "",
      allow_multiple_select: "",
      allow_quantity_selection: "",
      category_name: categoryForTab || -1,
    }
    if (categoryForTab?.length > 0)
      dispatch(getConfigurationListing(payload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryForTab]);

  useEffect(() => {
    setTabsData(configurationListing)
  }, [configurationListing]);

  useEffect(() => {
    if (configurationListing) {
      setTabsData(configurationListing);

      // Filter out properties not present in configurationListing
      const validProperties = (values?.variants || []).filter((prop) =>
        configurationListing.some((config) => config.id === prop.configuration_id)
      );

      // Find missing configuration_ids
      const missingConfigurations = configurationListing?.length > 0 && configurationListing?.filter(
        (config) =>
          !validProperties.some((prop) => prop.configuration_id === config.id)
      );

      // Add missing configurations with default values
      const defaultEntries = missingConfigurations?.length > 0 ? missingConfigurations?.map((config) => ({
        configuration_id: config.id,
        configuration_item_id: "",
        display_name: "",
        additional_info: "",
      })) : [];

      // Update the state with both valid and default entries
      const updatedProperties = [...validProperties, ...defaultEntries];

      setFormValues((prevValues) => ({
        ...prevValues,
        variants: updatedProperties,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurationListing]);


  const handleProductSpecChange = (e, name) => {
    setFormValues((prevState) => {
      // Check if the configuration_id exists
      const existingItem = values?.variants?.find(
        (item) => item.configuration_id === tabValueID
      );
      if (existingItem) {
        // Update the existing item
        return {
          ...prevState,
          variants: prevState.variants?.map((item) =>
            item.configuration_id === tabValueID
              ? { ...item, [name]: e }
              : item
          ),
        };
      }
    })
  }

  return (
    <React.Fragment>
      <Card className="p-3 px-2" style={{ minHeight: "40vh" }}>
        <CardBody style={{ width: width > 600 ? "auto" : width < 518 ? "85vw" : "90vw" }}>
          <div className="setting-header">PRODUCT SPECS</div>
          {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "variants.")}</FormHelperText>}
          <Divider className="my-2 mb-2" />
          {
            values?.product_categories?.length > 0 && categoryForTab?.length > 0 && configurationListing?.length > 0 ?
              <>
                <Tabs value={tabValue} scrollButtons={true} onChange={(e, val) => (setTabValue(val))} aria-label="basic tabs example" variant="scrollable" TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }}
                  sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                      '&.Mui-disabled': { opacity: 0.3 },
                    },
                  }}
                >
                  {
                    TabsData && TabsData.length > 0 && TabsData?.map((x, idx) =>
                      <Tab key={idx} label={<div className="d-flex" style={{ color: parseInt(tabValue) === idx ? '#282828' : '#A0A0A0' }}>{x?.descriptions?.[0]?.name}</div>} />
                    )
                  }
                </Tabs>
                {
                  values?.variants?.filter((x, id) => x.configuration_id === tabValueID)?.map((y, idx) =>
                    <Grid container spacing={2} pt={2} key={idx}>
                      <Grid item xs={12}>
                        <Grid item xs={12} >
                          <CustomSelect
                            title={'Type'}
                            values={y?.configuration_item_id || '-1'}
                            valueName={"id"}
                            error={error && error?.[`variants.${tabValue}.configuration_item_id`] && "The product spec type is required."}
                            labelName={"name"}
                            placeholder={"All"}
                            onChange={(e) => handleProductSpecChange(e, "configuration_item_id")}
                            data={configurationDetails?.items}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          title={'Specs Title'}
                          values={y?.display_name}
                          error={error && error?.[`variants.${tabValue}.display_name`] && "The product spec title is required."}
                          onChange={(e) => handleProductSpecChange(e, "display_name")}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          title={'Additional information'}
                          values={y?.additional_info}
                          error={error && error?.[`variants.${tabValue}.additional_info`] && "The product spec additional information is required."}
                          onChange={(e) => handleProductSpecChange(e, "additional_info")}
                          placeholder="e.g. E-cores up to 4.00 GHz P-cores up to 5.20 GHz)"
                        />
                        <FormHelperText>The specific details that highlighting options, which appears under the display name in the details page.</FormHelperText>
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          title={"Group Name"}
                          values={y?.group_name}
                          onChange={(e) => handleProductSpecChange(e, "group_name")}
                          subtitle={"To group related specifications. Users can select only one option from each group."}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CustomTextField
                          title={"Sort Order"}
                          values={y?.sort_order}
                          placeholder={"e.g. 0"}
                          subtitle={"Determines the display sequence. Items are shown in ascending order (lowest value first)."}
                          onChange={(e) => handleProductSpecChange(e, "sort_order")}
                          type="number"
                        />
                      </Grid>

                    </Grid>

                  )

                }
              </>
              :
              <span className="text-muted">No configurations found for this product's category.</span>
          }
        </CardBody>
      </Card>
    </React.Fragment >
  );
};

function mapStateToProps({ Configuration }) {
  return {
    configurationListing: Configuration.configurationListing.data,

  };
}


export default connect(mapStateToProps)(ProductSpec);
